export const environment = {
  production: true,
  apiUrl: 'https://api.partsauto.ge/api/',
  defaultDoamin: 'https://partsauto.ge/',
};
